import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CollectionPointAddEdit, CollectionPointListing } from './Pages';

export const CollectionPointRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CollectionPointListing} />
        <Route exact path={`${match.path}/AddEdit`} component={CollectionPointAddEdit} />
    </Fragment>
)